import { useState } from 'react';
import styles from '../styles/nav.module.css';
import Logo from './logo.jpeg';


const NavBar = () => {

    const [showMenu, setShowMenu] = useState(false);

    const navMenuItems = document.getElementsByClassName('navMenuItems')[0];

    if(showMenu) {
        navMenuItems.style.display="flex";
        navMenuItems.style.flexDirection="column";
    // } else {
    //     navMenuItems.style.display="none";
    }

    // const toggleMenu = () => navMenuItems.current.classList.toggle('active');

    return (
        <div className={styles.navBar}>
            <div className={styles.navLeft}>

                <a href="/">
                    <img src={Logo} className={styles.logo} alt="JAAS Logo" />
                </a>                
                
            </div>

            <div className={styles.navRight}>
                <svg viewBox="0 0 100 80" width="40" height="40" className={styles.navHamburger} onClick = {() => setShowMenu(!showMenu)}>
                <rect width="100" height="10" rx="8"></rect>
                <rect y="30" width="100" height="10" rx="8"></rect>
                <rect y="60" width="100" height="10" rx="8"></rect>
                </svg>

                <div className={`${styles.navMenuItems} navMenuItems`}>
                    <a href="/" className={`${styles.navLink} ${styles.navHome}`}>
                        Home
                    </a>
                    <a href="portfolio" className={styles.navLink}>
                        Portfolio
                    </a>

                    <a href="contact" className={styles.navLink}>
                        Contact
                    </a>
                </div>

                {/* <div className={`${styles.navMenuItemsMobile} navMenuItemsMobile`}>
                    <a href="/" className={`${styles.navLinkMobile} ${styles.navHomeMobile}`}>
                        Home
                    </a>
                    <a href="portfolio" className={styles.navLinkMobile}>
                        Portfolio
                    </a>

                    <a href="contact" className={styles.navLinkMobile}>
                        Contact
                    </a>
                </div>                                      */}
            </div>
        </div>
    );
}
 
export default NavBar;